/**
 * Tracked product copy for “Transfer repayment to savings” (roles UI, tooltips, confirmations).
 * Change here to update all usages.
 */
export const TRANSFER_REPAYMENT_TO_SAVINGS = Object.freeze({
	label: "Transfer repayment to savings",
	description:
		"Reverse a loan repayment and deposit the amount to the member's savings account.",
});

/** Roles / permissions table: checkbox label only (description is tooltip — see UserPermissionsTable). */
export function transferRepaymentToSavingsPermissionLabel() {
	return TRANSFER_REPAYMENT_TO_SAVINGS.label;
}

/** SweetAlert2 dialog title (question form). */
export function transferRepaymentToSavingsConfirmTitle() {
	return `${TRANSFER_REPAYMENT_TO_SAVINGS.label}?`;
}
